import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices

import authReducer from "./slices/auth";
import blogReducer from "./slices/blog";
import categoryReducer from "./slices/category";
import contactReducer from "./slices/contact";
import houseReducer from "./slices/house";
import orderReducer from "./slices/order";
import productReducer from "./slices/product";
import schoolReducer from "./slices/school";
import sizeReducer from "./slices/size";
import typesReducer from "./slices/type";
import userReducer from "./slices/user";
// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const blogPersistConfig = {
  key: "blog",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const schoolPersistConfig = {
  key: "school",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const sizePersistConfig = {
  key: "size",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const categoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const housePersistConfig = {
  key: "house",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const typePersistConfig = {
  key: "type",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const contactPersistConfig = {
  key: "contact",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const userPersistConfig = {
  key: "user",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const orderPersistConfig = {
  key: "order",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const authPersistConfig = {
  key: "auth",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

const rootReducer = combineReducers({
  blog: persistReducer(blogPersistConfig, blogReducer),
  school: persistReducer(schoolPersistConfig, schoolReducer),
  size: persistReducer(sizePersistConfig, sizeReducer),
  category: persistReducer(categoryPersistConfig, categoryReducer),
  house: persistReducer(housePersistConfig, houseReducer),
  product: persistReducer(productPersistConfig, productReducer),
  type: persistReducer(typePersistConfig, typesReducer),
  contact: persistReducer(contactPersistConfig, contactReducer),
  user: persistReducer(userPersistConfig, userReducer),
  order: persistReducer(orderPersistConfig, orderReducer),
  auth: persistReducer(authPersistConfig, authReducer),
});

export default rootReducer;
